import { Component } from '@angular/core';
import { UploadFileService } from 'src/app/shared/services/upload-file.service';

@Component({
  selector: 'app-upload-file-list',
  templateUrl: './upload-file-list.component.html',
  styleUrls: ['./upload-file-list.component.scss'],
})
export class UploadFileListComponent {
  files!: string[];

  constructor(private uploadFileService: UploadFileService) {}

  ngOnInit() {
    this.uploadFileService.getFileList().subscribe(
      (files) => {
        this.files = files;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
